export default __webpack_public_path__ + "static/Declaration-Aqad_EGTB_MY-d628fc3cf17516a8782619ab4e5fbca9.pdf";